import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {NoteDataService} from './impl.service/noteData.service';
import {NoteRepository} from './impl.service/note.repository';

@NgModule()
export class PartnerNoteModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: NoteDataService,
                repository: NoteRepository,
    ) {

        entityDataService.registerServices({
            Note: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Note: repository,
        });

    }
}
